var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagiclogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.4219 0C44.0743 4.24029 48.1027 8.17813 52.4589 11.7678C49.5562 20.6919 47.9936 30.1729 47.9936 40C47.9936 49.8271 49.5562 59.3081 52.4589 68.2322C48.1027 71.8219 44.0743 75.7597 40.4219 80C36.7695 75.7597 32.7411 71.8219 28.3849 68.2322C31.2875 59.3081 32.8502 49.8271 32.8502 40C32.8502 30.173 31.2875 20.6919 28.3849 11.7678C32.7411 8.17814 36.7695 4.24029 40.4219 0Z",
    fill: "url(#paint0_linear_2992_33912)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0585 62.0623C15.4474 58.9988 10.5537 56.2914 5.42188 53.9822C6.84542 49.5593 7.61121 44.8644 7.61121 40C7.61121 35.1356 6.84542 30.4407 5.42187 26.0178C10.5537 23.7086 15.4474 21.0012 20.0585 17.9377C21.8216 25.0203 22.7546 32.4069 22.7546 40C22.7546 47.5931 21.8216 54.9797 20.0585 62.0623Z",
    fill: "url(#paint1_linear_2992_33912)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0891 40C58.0891 47.5931 59.0221 54.9797 60.7853 62.0623C65.3964 58.9988 70.29 56.2914 75.4219 53.9822C73.9983 49.5593 73.2325 44.8644 73.2325 40C73.2325 35.1356 73.9983 30.4407 75.4219 26.0178C70.29 23.7086 65.3964 21.0012 60.7853 17.9377C59.0221 25.0203 58.0891 32.4069 58.0891 40Z",
    fill: "url(#paint2_linear_2992_33912)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2992_33912",
    x1: 40.4219,
    y1: 0,
    x2: 40.4219,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522FD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2992_33912",
    x1: 40.4219,
    y1: 0,
    x2: 40.4219,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522FD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2992_33912",
    x1: 40.4219,
    y1: 0,
    x2: 40.4219,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#874FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522FD4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagiclogo);
export default __webpack_public_path__ + "static/media/magiclogo.06d8ef2c500f5f3643e4f4967789742b.svg";
export { ForwardRef as ReactComponent };